const ProductListingNoResultsView = () => (
  <div className="text-center w-full my-10" data-testid="product-listing-no-results-view">
    <h2 className="uppercase text-primary heading-lg">No results</h2>
    <p className="mt-4 text-lg">
      Sorry, we can&apos;t find any results for your criteria
    </p>
  </div>
)

export default ProductListingNoResultsView